import { getCurrentUserId, getOrgUserById } from 'conversations/modules/user/selectors'
import { getDisplayName } from 'conversations/utils/nameUtils'
import { useSelector } from 'react-redux'
import { User } from 'shared/typings/user/User'

import { RootState } from 'typesafe-actions'

export const useOrgUserDisplayName = (orgUserId: number | undefined): string | undefined =>
  useSelector<RootState, string | undefined>((state: RootState) => {
    if (!orgUserId) {
      return undefined
    }
    const orgUser = getOrgUserById(state, orgUserId)
    return getDisplayName(orgUser)
  })

export const useOrgUser = (orgUserId: number | undefined): User | undefined =>
  useSelector<RootState, User | undefined>((state: RootState) => {
    if (!orgUserId) {
      return undefined
    }
    return getOrgUserById(state, orgUserId)
  })

export const useCurrentUserId = (): number | undefined => {
  return useSelector<RootState, number | undefined>(getCurrentUserId)
}

export const useCurrentUserDisplayName = (): string | undefined => {
  return useOrgUserDisplayName(useCurrentUserId())
}
